/* eslint-disable max-lines-per-function */
import { Markierung } from '@/domain/arbeitszeiten/components/Markierung';
import { Abteilung } from '@/domain/arbeitszeiten/entities';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { getColorByOption } from '@/domain/arbeitszeiten/components/Comboboxen/AbteilungsCombobox/getColorByOption';
import {
  Checkbox,
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  PopoverContent,
} from '@e2n/ui';

export function AbteilungComboboxPopoverContent({
  selectedAbteilungen,
  setSelectedAbteilungen,
  onSelect,
  abteilungen,
}: {
  selectedAbteilungen: Abteilung[];
  setSelectedAbteilungen: Dispatch<SetStateAction<Abteilung[]>>;
  onSelect: (abteilungen: Abteilung[]) => void;
  abteilungen: Abteilung[];
}) {
  const { t } = useTranslation();

  function handleSelect(currentValue: string) {
    const selectedIds = selectedAbteilungen.map((abteilung) => abteilung.id);

    const id = currentValue.split('% %')[1];

    if (selectedIds.includes(id)) {
      setSelectedAbteilungen((selectedAbteilungen) => {
        onSelect(
          selectedAbteilungen.filter(
            (selectedAbteilungen) => selectedAbteilungen.id !== id,
          ),
        );
        return selectedAbteilungen.filter(
          (selectedAbteilungen) => selectedAbteilungen.id !== id,
        );
      });
    } else {
      setSelectedAbteilungen((selectedAbteilungen) => {
        const abteilung = abteilungen.find((abteilung) => abteilung.id === id);
        onSelect([...selectedAbteilungen, abteilung]);
        return [...selectedAbteilungen, abteilung];
      });
    }
  }

  return (
    <PopoverContent className="w-[280px] p-0">
      <Command
        filter={(value, search) => {
          if (
            value
              .split('% %')[0]
              .toLocaleLowerCase()
              .includes(search.toLocaleLowerCase())
          ) {
            return 1;
          }
          return 0;
        }}>
        <CommandInput
          placeholder={t(
            'domain.arbeitszeiten.uebersicht.abteilungfilter.search',
          )}
          className="h-9"
        />
        <CommandList>
          <CommandEmpty className="text-center text-neutrals-700 pb-4 text-sm">
            {t('domain.arbeitszeiten.uebersicht.abteilungfilter.notFound')}
          </CommandEmpty>
          <CommandGroup>
            {abteilungen.map((abteilung) => {
              const isSelected = selectedAbteilungen.find(
                (selectedAbteilungen) =>
                  selectedAbteilungen.id === abteilung.id,
              );

              return (
                <CommandItem
                  key={abteilung.id}
                  //Wird benötigt um eindeutige Arbeitsbereiche zu haben, die den gleichen namen haben.
                  //Wird in der Filter funktion ausgewertet
                  //Und ja ich schäme mich dafüer aber andere Lösungen finde ich nicht :'(
                  value={`${abteilung.name}% %${abteilung.id}`}
                  onSelect={(currentValue) => {
                    handleSelect(currentValue);
                  }}>
                  <div className="flex justify-between items-center w-full font-normal">
                    <div className="flex gap-2 items-center truncate max-w-36">
                      <Markierung
                        color={getColorByOption(abteilung.id, abteilungen)}
                      />
                      <span className="truncate">{abteilung.name}</span>
                    </div>
                    <Checkbox
                      checked={isSelected !== undefined}
                      disabled
                      className="disabled:opacity-100 disabled:cursor-auto"
                    />
                  </div>
                </CommandItem>
              );
            })}
          </CommandGroup>
        </CommandList>
      </Command>
    </PopoverContent>
  );
}
